// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".stat-row[data-v-140f1750]:not(:first-child){border-top:1px solid rgba(255,255,255,.38)}.divider.divider[data-v-140f1750]{border-width:.5px}.results-logo[data-v-140f1750]{max-width:2.5em;max-height:100%}@media(min-width: 1264px){.results-logo[data-v-140f1750]{max-width:3.5em}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
